export default "__VITE_ASSET__91ed7efa__"